var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import eachMinuteOfInterval from 'date-fns/eachMinuteOfInterval';
import { BookModelCollection } from '../BookModelCollection';
import first from "lodash/first";
import endOfDay from 'date-fns/endOfDay';
import addDays from 'date-fns/addDays';
import addMinutes from 'date-fns/addMinutes';
import orderBy from "lodash/orderBy";
var SchedulingTimeRangeModelCollection = /** @class */ (function (_super) {
    __extends(SchedulingTimeRangeModelCollection, _super);
    function SchedulingTimeRangeModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SchedulingTimeRangeModelCollection.prototype.generateRangesForDays = function (maxDaysInFuture, date, filter) {
        if (filter === void 0) { filter = function (model) { return true; }; }
        var filtered = this.filter(filter);
        var ranges = filtered.all().reduce(function (theRanges, timeRange) {
            return theRanges.concat(timeRange.generateRangesForDays(maxDaysInFuture, date));
        }, []);
        return orderBy(ranges, ["from", "priority"], ["asc", "desc"])
            .filter(function (range, i, self) { return range.from <= endOfDay(addDays(first(self).from, maxDaysInFuture)); });
    };
    SchedulingTimeRangeModelCollection.prototype.generateIncludedRangesForDays = function (maxDaysInFuture, date) {
        return this.generateRangesForDays(maxDaysInFuture, date, function (r) { return r.isIncluding; });
    };
    SchedulingTimeRangeModelCollection.prototype.generateExcludedRangesForDays = function (maxDaysInFuture, date) {
        return this.generateRangesForDays(maxDaysInFuture, date, function (r) { return !r.isIncluding; });
    };
    SchedulingTimeRangeModelCollection.prototype.generateSlots = function (maxDaysInFuture, date, filter) {
        if (filter === void 0) { filter = function (model) { return true; }; }
        var ranges = this.generateRangesForDays(maxDaysInFuture, date, filter);
        return ranges.reduce(function (theSlots, timeRange) {
            var slots = eachMinuteOfInterval({
                start: timeRange.from,
                end: timeRange.to,
            }, { step: timeRange.slotInterval })
                // Only add slots that start before the end of the range
                .filter(function (date) { return date < timeRange.to; })
                .map(function (slotStart) {
                return {
                    slotStart: slotStart,
                    priority: timeRange.priority,
                    maxBookings: timeRange.maxBookings,
                    slotInterval: timeRange.slotInterval,
                    slotEnd: addMinutes(slotStart, timeRange.slotInterval)
                };
            });
            return theSlots.concat(slots);
        }, []);
    };
    SchedulingTimeRangeModelCollection.prototype.generateAvailableSlotDates = function (maxDaysInFuture, date) {
        return this.generateSlots(maxDaysInFuture, date, function (r) { return r.isIncluding; });
    };
    return SchedulingTimeRangeModelCollection;
}(BookModelCollection));
export { SchedulingTimeRangeModelCollection };
